import React from 'react';
import { Loader2 } from 'lucide-react';

// Suspense fallback shown while a lazy-loaded route chunk downloads.
// Kept tiny and eagerly imported (no lazy() on this one) so it's always
// available instantly — the whole point of a loading state.
export default function PageLoader({ fullScreen = true }) {
  return (
    <div
      className={`flex items-center justify-center bg-white ${fullScreen ? 'min-h-screen' : 'py-24'}`}
      data-testid="page-loader"
    >
      <Loader2 className="w-8 h-8 animate-spin text-blue-700" />
    </div>
  );
}
